import { array, mixed, number, object, string } from 'yup';

const rolesSchema = array().of(string());

export const personalDetailsAdvisorOnboarding = {
  advisorRoles: rolesSchema,

  advisorID: string().uuid('Invalid UUID').required('Advisor ID is required'),
  advisorIDNotRequired: string().uuid('Invalid UUID').notRequired(),
  fcaReferenceNumber: string().required('FCA Reference Number is required'),
  intelifloReferenceNumber: string().required('CRM Reference Number is required'),
  fcaReferenceNumberNotRequired: string().notRequired(),
  fcaAuthoriseStatus: string().required('FCA Authorise Status is required'),
  fcaAuthoriseStatusNotRequired: string().notRequired(),
  totalFCAMembers: number().required('Total FCA Members is required').integer(), // positive integer??
  totalFCAMembersNotRequired: number().notRequired(),
  advisorType: string().required('Advisor Type is required'),
  advisorTypeNotRequired: string().notRequired(),
  userProfilesFile: mixed<File>()
    .required('A file is required')
    .test('fileSize', 'File is too large', (value) => {
      return value && value.size <= 5242880;
    })
    .test('fileType', 'Unsupported file format', (value) => {
      return value && value.type === 'text/csv';
    })
    .nullable(),
  userProfilesFileNotRequired: mixed().nullable().notRequired(),

  usersCSV: object()
    .shape({
      id: string().uuid().notRequired(),
      status: string().notRequired(),
      createdAt: string().notRequired(),
      updatedAt: string().notRequired(),
      advisorID: string().uuid().notRequired(),
      documentID: string().uuid().notRequired(),
      documentName: string()
        .matches(/.*\.csv$/, 'Document name must be a CSV file')
        .notRequired(),
    })
    .nullable()
    .notRequired(),
};
